import { createServerFn } from '@tanstack/react-start'
import { env } from 'cloudflare:workers'
import { getDb } from '../db/client'
import { type RankingEntry, getRanking } from '../db/queries'

export const RANKING_SIZE = 100

export const getRankingFn = createServerFn({ method: 'GET' }).handler(
  async (): Promise<RankingEntry[]> => getRanking(getDb(env.DB), RANKING_SIZE),
)
